import consts from "./consts";
import axios from "axios";
import { NewResults } from '@/types/NewResults';
import { InitAssessmentPost } from "@/types";
import { getPropertyByKeys } from "./utils";
import { UserSessionResult, SessionFeedback, Rubric, RubricSession, CreateRubric, RubricUpdate, TeamReviewSettings, TeamReviewers } from './types';

export function fetchUserSessionResult(JWT: string, sessionID: string, onSuccess: Function, onError: Function): any {
  axios({
    url:
      consts.serverURL + `session-ng/${sessionID}?newresults=true`,
    headers: { Authentication: JWT },

  }).then(
    response => {
      console.log("Fetch Users Session", response.data);
      const sessionResult: NewResults = response && response.data;
      onSuccess(sessionResult);
    },
    error => {
      console.error(error);
      if(error && error.response) {
        const errorMsg = error.response.data.Error;
        if(errorMsg && errorMsg.length>0) {
          onError(errorMsg);
        } else {
          onError(error);
        }
      } else {
        onError(error);
      }
    }
  );
}

export function fetchUserSessionFeedback(JWT: string, sessionID: string, onSuccess: Function, onError: Function): any {
  axios({
    url:
      consts.serverURL + `session/${sessionID}/manager-feedback`,
    headers: { Authentication: JWT },

  }).then(
    response => {
      console.log("Fetch Users Session Feedback", response.data);
      const sessionResult: UserSessionResult = response && response.data;
      onSuccess(sessionResult);
    },
    error => {
      console.error(error);
      onError(error);
    }
  );
}

export function addCommentFeedback(JWT: string, sessionId: string, comments: string,
  feedbackID: string, startIndex: number, endIndex: number, onSuccess: Function, onError: Function): any {

  let data: any = { Comments: comments };

  if (startIndex >= 0 && endIndex >= 0) {
    data.StartIndex = startIndex;
    data.EndIndex = endIndex;
  }

  var method: string
  var url: string
  if (feedbackID) {
    method = "PUT";
    url = consts.serverURL + "session/" + sessionId + "/manager-feedback/" + feedbackID;
  } else {
    method = "POST";
    url = consts.serverURL + "session/" + sessionId + "/manager-feedback/";
  }

  axios({ method, url, headers: { Authentication: JWT }, data })
    .then(
      response => {
        console.log("Add Comment", response.data);
        const sessionFeedback: SessionFeedback = response && response.data
        onSuccess(sessionFeedback);
      },
      error => {
        console.error(error);
        onError(error);
      }
    );
}

export function deleteCommentFeedback(JWT: string, sessionId: string,
  feedbackID: string, onSuccess: Function, onError: Function): any {
  axios({
    method: "DELETE", url: consts.serverURL + "session/" + sessionId + "/manager-feedback/" + feedbackID,
    headers: { Authentication: JWT }
  })
    .then(
      response => {
        console.log("Delete Comment", response.data);
        onSuccess(response.data);
      },
      error => {
        console.error(error);
        onError(error);
      }
    );
}

export function fetchDefaultRubric(JWT: string, teamID: string, onSuccess: Function, onError: Function): any {
  axios({
    url:
      consts.serverURL + `rubric/default/${teamID}`,
    headers: { Authentication: JWT },

  }).then(
    response => {
      console.log("Fetch Rubric", response.data);
      const rubric: Rubric = response && response.data;
      onSuccess(rubric);
    },
    error => {
      console.error(error);
      onError(error);
    }
  );
}

export function fetchRubricSession(JWT: string, sessionID: string, onSuccess: Function, onError: Function): any {
  axios({
    url:
      consts.serverURL + `rubric/session/${sessionID}`,
    headers: { Authentication: JWT },
  }).then(response => {
    console.log("Fetch Rubric Session", response.data);
    const rubricSession: RubricSession[] = response && response.data;
    onSuccess(rubricSession);
  },
    error => {
      console.error(error);
      onError(error);
    }
  );
}

export function submitRubricSession(JWT: string, sessionID: string, rubricSlug: string, rubricVersion: string, sessionAnswers: any, onSuccess: Function, onError: Function): any {
  axios({
    method: "POST",
    url: `${consts.serverURL}rubric/session/${rubricSlug}/${rubricVersion}/${sessionID}`,
    headers: { Authentication: JWT },
    data: sessionAnswers
  }).then(response => {
    console.log("SUBMIT RUBRIC", response);
    onSuccess(response)
  })
    .catch(reason => {
      console.log(reason, reason.response);
      onError(reason)
    });
}

export function submitReview(JWT: string, teamID: string, sessionID: string, onSuccess: Function, onError: Function): any {
  axios({
    method: "POST",
    url: `${consts.serverURL}review/${teamID}/submit-review/${sessionID}`,
    headers: { Authentication: JWT }
  })
    .then(response => {
      console.log("Submit Feedback", response);
      onSuccess(response)
    })
    .catch(reason => {
      console.log(reason, reason.response);
      onSuccess(reason);
    });
}

export function createRubric(JWT: string, teamID: string, rubric: any, onSuccess: Function, onError: Function): any {
  axios({
    method: "POST",
    url: `${consts.serverURL}rubric/${teamID}`,
    headers: { Authentication: JWT },
    data: rubric
  })
    .then(response => {
      console.log("Create Rubric", response);
      const createRubric: CreateRubric = response && response.data;
      onSuccess(createRubric)
    })
    .catch(reason => {
      if (!reason.response) {
        // network error
        onError("Network Error");
      } else {
        const errorMsg = reason.response.data.Error;
        if (errorMsg && errorMsg.length > 0) {
          onError(errorMsg);
        } else {
          onError(null)
        }
      }
    });
}

export function setDefaultRubric(JWT: string, slug: string, onSuccess: Function, onError: Function): any {
  axios({
    method: "POST",
    url: consts.serverURL + "rubric/default/" + slug,
    headers: { Authentication: JWT }
  })
    .then(response => {
      console.log("SET DEFAULT RUBRIC", response);
      onSuccess(response)
    })
    .catch(reason => {
      if (!reason.response) {
        // network error
        onError("Network Error");
      } else {
        const errorMsg = reason.response.data.Error;
        if (errorMsg && errorMsg.length > 0) {
          onError(errorMsg);
        } else {
          onError(null)
        }
      }
    });
}

export function updateRubric(JWT: string, rubric: any, onSuccess: Function, onError: Function) {
  let data = {
    name: rubric.name,
    version: rubric.version,
    questions: rubric.questions
  };
  axios({
    method: "PUT",
    url: consts.serverURL + "rubric/" + rubric.rubricSlug,
    headers: { Authentication: JWT },
    data
  })
    .then(response => {
      console.log("UPDATE RUBRIC", response.data);
      const rubricUpdate: RubricUpdate = response && response.data;
      onSuccess(rubricUpdate)
    })
    .catch(reason => {
      if (!reason.response) {
        // network error
        onError("Network Error");
      } else {
        const errorMsg = reason.response.data.Error;
        if (errorMsg && errorMsg.length > 0) {
          onError(errorMsg);
        } else {
          onError(null)
        }
      }
    });
}

export function deleteRubric(JWT: string, rubric: any, onSuccess: Function, onError: Function) {
  if (rubric.rubricSlug && rubric.version) {
    axios({
      method: "DELETE",
      url: consts.serverURL + "rubric/" + rubric.rubricSlug + "/" + rubric.version,
      headers: { Authentication: JWT }
    })
      .then(response => {
        console.log("DELETE RUBRIC");
        onSuccess(response);
      })
      .catch(reason => {
        if (!reason.response) {
          // network error
          onError("Network Error");
        } else {
          const errorMsg = reason.response.data.Error;
          if (errorMsg && errorMsg.length > 0) {
            onError(errorMsg);
          } else {
            onError(null)
          }
        }
      });
  }
}

export function deleteRecording(JWT: string, sessionID: string, onSuccess: Function, onError: Function) {
  axios({
    method: "DELETE",
    url: consts.serverURL + "session/" + sessionID,
    headers: { Authentication: JWT }
  })
    .then(response => {
      onSuccess(response);
    })
    .catch(reason => {
      const errorMsg = reason.response.data.Error;
      if (errorMsg && errorMsg.length > 0) {
        onError(errorMsg);
      }
    });
}

export function fetchTeamReviewSettings(JWT: string, teamID: string, onSuccess: Function, onError: Function): any {
  axios({
    url:
      consts.serverURL + `review/${teamID}/settings`,
    headers: { Authentication: JWT },

  }).then(
    response => {
      console.log("Fetch Team Settings", response.data);
      const teamReviewSettings: TeamReviewSettings = response && response.data;
      onSuccess(teamReviewSettings);
    })
    .catch(reason => {
      const errorMsg = reason.response.data.Error;
      if (errorMsg && errorMsg.length > 0) {
        onError(errorMsg);
      }
    });
}

export function updateTeamReviewSettings(JWT: string, teamID: string, teamReviewSettings: TeamReviewSettings, onSuccess: Function, onError: Function): any {

  let data = {

    method: teamReviewSettings.method,
    version: teamReviewSettings.version,
    reviewers: teamReviewSettings.reviewers.map(reviewer => ({ uid: reviewer.uid, reviewees: reviewer.reviewees.map(reviewee => ({ uid: reviewee.uid })) }))
  };
  axios({
    method: "PUT",
    url:
      consts.serverURL + `review/${teamID}/settings`,
    headers: { Authentication: JWT },
    data
  }).then(
    response => {
      console.log("Fetch Team Settings", response.data);
      const teamReviewSettings: TeamReviewSettings = response && response.data;
      onSuccess(teamReviewSettings);
    })
    .catch(reason => {
      const errorMsg = reason.response.data.Error;
      if (errorMsg && errorMsg.length > 0) {
        onError(errorMsg);
      }
    });
}


export function teamCode(JWT: string, uid: string, teamCode: string, onSuccess: Function, onError: Function): any {

  axios({
    method: "POST",
    url: `${consts.serverURL}user/${uid}/customcode/${teamCode}`,
    headers: { Authentication: JWT },
  }).then(
    response => {
      let description = getPropertyByKeys(response, ["data", "Description"]);
      onSuccess(description);
    })
    .catch(reason => {
      const errorMsg = reason.response.data.Error;
      if (errorMsg && errorMsg.length > 0) {
        onError(errorMsg);
      }
    });
}

export function deleteTeam(JWT: string, teamID: string): any {

  axios({
    method: "DELETE",
    url:
      consts.serverURL + `team/${teamID}`,
    headers: { Authentication: JWT }
  }).then()
    .catch();
}

export function postAssessmentApi(JWT: string, uid: string, initAssessmentPost: InitAssessmentPost, onSuccess: Function, onError: Function): any {

  axios({
    method: "POST",
    url: `${consts.serverURL}user/${uid}/journey/init-evaluation`,
    headers: { Authentication: JWT },
    data: initAssessmentPost
  }).then(
    response => {
      let description = getPropertyByKeys(response, ["data", "Description"]);
      onSuccess(description);
    })
    .catch(reason => {
      const errorMsg = reason.response.data.Error;
      if (errorMsg && errorMsg.length > 0) {
        onError(errorMsg);
      }
    });
}